export default "__VITE_ASSET__CezrJR6r__"